module.exports = __webpack_public_path__ + "img/logo-house-medium-4.7fe64aa9.svg";